/* eslint-disable */
/**
 * Calendario, alarmas y resumen de rangos seleccionados.
 *
 * Estos métodos operan sobre la instancia de PanelLogic y conservan el
 * contrato del prototipo importado. No mantienen estado global propio.
 */
const logic = {
  calVals(st) {
    const F = this.full,
      N = F.days.length,
      a = st.rngA ?? 0,
      b = st.rngB ?? N - 1,
      MES = ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic'],
      MESL = ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'];
    const D0 = this.calDate(0),
      idxOf = d => Math.round((new Date(d.getFullYear(), d.getMonth(), d.getDate()) - D0) / 864e5),
      now = new Date(),
      TD = idxOf(now);
    const fd = i => {
        const d = this.calDate(i);
        return d.getDate() + ' ' + MES[d.getMonth()] + ' ' + d.getFullYear();
      },
      fl = i => {
        const d = this.calDate(i);
        return d.getDate() + ' de ' + MESL[d.getMonth()] + (d.getFullYear() !== now.getFullYear() ? ' ' + d.getFullYear() : '');
      };
    const hasD = i => i >= 0 && i < N,
      dCount = (x, y) => Math.max(0, Math.min(N - 1, y) - Math.max(0, x) + 1);
    const pa = st.calA ?? a,
      pb = st.calA != null ? st.calB : b,
      hv = st.calHv;
    const lo = pb == null ? Math.min(pa, hv ?? pa) : Math.min(pa, pb),
      hi = pb == null ? Math.max(pa, hv ?? pa) : Math.max(pa, pb);
    const vm = st.calVM ?? (() => {
      const d = this.calDate(b);
      return d.getFullYear() * 12 + d.getMonth();
    })();
    const month = (ym, tag) => {
      const y = Math.floor(ym / 12),
        mo = ym % 12,
        first = new Date(y, mo, 1),
        sh = (first.getDay() + 6) % 7,
        nd = new Date(y, mo + 1, 0).getDate(),
        cells = [];
      for (let q = 0; q < 42; q++) {
        const d = new Date(y, mo, 1 - sh + q),
          i = idxOf(d),
          inM = d.getMonth() === mo,
          inR = i >= lo && i <= hi,
          isLo = i === lo,
          isHi = i === hi,
          dow = q % 7,
          td = i === TD,
          data = hasD(i);
        const band = inR && inM && !(isLo && isHi);
        cells.push({
          n: inM ? String(d.getDate()) : '',
          vis: inM ? 1 : 0,
          c: (isLo || isHi) && inM ? '#fff' : inR && inM ? '#f3e2d6' : dow >= 5 ? '#8793a6' : '#d5dbe4',
          dot: data ? isLo || isHi ? '#fff' : 'oklch(0.75 0.11 190)' : 'transparent',
          fw: isLo || isHi ? 700 : 500,
          cbg: (isLo || isHi) && inM ? 'oklch(0.62 0.18 42)' : 'transparent',
          ring: td && inM ? "inset 0 0 0 0.138889vh oklch(0.75 0.11 190)" : 'none',
          band: band ? 'oklch(0.62 0.18 42 / 0.2)' : 'transparent',
          bl: band && (isLo || dow === 0 || d.getDate() === 1) ? "1.574074vh" : '0',
          br: band && (isHi || dow === 6 || d.getDate() === nd) ? "1.574074vh" : '0',
          click: () => {
            if (!inM) return;
            this.setState(s => s.calA == null || s.calB != null ? {
              calA: i,
              calB: null
            } : {
              calB: i
            });
          },
          enter: () => {
            if (inM) this.setState({
              calHv: i
            });
          }
        });
      }
      const pk = st.calPick === tag,
        py = pk ? st.calPY ?? y : y,
        D1 = this.calDate(N - 1);
      const pMonths = MES.map((ml, k) => {
        const cur = py === y && k === mo,
          has = py * 12 + k >= D0.getFullYear() * 12 + D0.getMonth() && py * 12 + k <= D1.getFullYear() * 12 + D1.getMonth();
        return {
          l: ml.charAt(0).toUpperCase() + ml.slice(1),
          bg: cur ? 'oklch(0.62 0.18 42)' : 'rgba(255,255,255,0.03)',
          bd: cur ? 'oklch(0.62 0.18 42)' : 'rgba(184,193,206,0.14)',
          c: cur ? '#fff' : '#d5dbe4',
          dot: has ? cur ? '#fff' : 'oklch(0.75 0.11 190)' : 'transparent',
          go: () => this.setState({
            calVM: py * 12 + k + (tag === 'prev' ? 1 : 0),
            calPick: null,
            calPY: null
          })
        };
      });
      return {
        pick: () => this.setState(s => ({
          calPick: s.calPick === tag ? null : tag,
          calPY: y
        })),
        pOpen: pk,
        pYear: String(py),
        pMonths,
        pbg: pk ? 'rgba(232,80,20,0.12)' : 'transparent',
        pbd: pk ? 'oklch(0.62 0.18 42)' : 'transparent',
        yPrev: () => this.setState({
          calPY: py - 1
        }),
        yNext: () => this.setState({
          calPY: py + 1
        }),
        isPrev: tag === 'prev',
        isCur: tag === 'cur',
        tag,
        title: MESL[mo].charAt(0).toUpperCase() + MESL[mo].slice(1) + ' ' + y,
        cells
      };
    };
    const sel = (A, B) => () => this.setState({
      calA: A,
      calB: B,
      calHv: null,
      calVM: (() => {
        const d = this.calDate(B);
        return d.getFullYear() * 12 + d.getMonth();
      })()
    });
    const td = this.calDate(TD),
      wd = (td.getDay() + 6) % 7,
      mS = idxOf(new Date(td.getFullYear(), td.getMonth(), 1)),
      pmS = idxOf(new Date(td.getFullYear(), td.getMonth() - 1, 1));
    const pre = [['Hoy', TD, TD], ['Ayer', TD - 1, TD - 1], ['Últimos 7 días', TD - 6, TD], ['Últimos 30 días', TD - 29, TD], ['Esta semana', TD - wd, TD], ['Semana pasada', TD - wd - 7, TD - wd - 1], ['Este mes', mS, TD], ['Mes pasado', pmS, mS - 1], ['Todo con datos', 0, N - 1]];
    const sa = Math.min(pa, pb ?? pa),
      sb = Math.max(pa, pb ?? pa),
      cnt = sb - sa + 1,
      dc = dCount(sa, sb),
      nRng = b - a + 1,
      nDat = dCount(a, b);
    const nd = st.calNd ?? 30,
      endN = st.calB != null ? sb : TD;
    const years = [];
    for (let y = now.getFullYear() - 3; y <= now.getFullYear(); y++) years.push(y);
    return {
      rngHdr: fl(a) + ' - ' + fl(b) + ', ' + nRng + ' días' + (nDat < nRng ? ' (' + nDat + ' con datos)' : ''),
      rngShort: fd(a) + ' – ' + fd(b),
      rngN: String(nRng),
      calOpen: !!st.calOpen,
      openCal: () => this.setState({
        calOpen: true,
        calA: a,
        calB: b,
        calVM: null,
        calHv: null
      }),
      closeCal: () => this.setState({
        calOpen: false,
        calA: null,
        calB: null,
        calHv: null,
        calVM: null,
        calPick: null
      }),
      calFrom: fd(sa),
      calTo: pb == null ? 'elige el día de fin' : fd(sb),
      calToC: pb == null ? '#8793a6' : '#e4e9f0',
      calCnt: String(pb == null ? 1 : cnt),
      calDat: dc ? dc + ' de ' + (pb == null ? 1 : cnt) + ' días con datos' : 'Sin datos en este rango',
      calDatC: dc ? 'oklch(0.75 0.11 190)' : 'oklch(0.8 0.15 75)',
      calCovW: ((pb == null ? hasD(sa) ? 1 : 0 : dc / cnt) * 100).toFixed(1) + '%',
      calMonths: [month(vm - 1, 'prev'), month(vm, 'cur')],
      calApplyOp: pb != null ? 1 : 0.4,
      calPrev: () => this.setState({
        calVM: vm - 1
      }),
      calNext: () => this.setState({
        calVM: vm + 1
      }),
      calLeave: () => this.setState({
        calHv: null
      }),
      calMOpts: MESL.map((m, k) => ({
        v: String(k),
        l: m.charAt(0).toUpperCase() + m.slice(1),
        sel: k === vm % 12
      })),
      calYOpts: years.map(y => ({
        v: String(y),
        l: String(y),
        sel: y === Math.floor(vm / 12)
      })),
      calMKey: 'm' + vm,
      calMVal: String(vm % 12),
      calYVal: String(Math.floor(vm / 12)),
      onCalM: e => this.setState({
        calVM: Math.floor(vm / 12) * 12 + +e.target.value
      }),
      onCalY: e => this.setState({
        calVM: +e.target.value * 12 + vm % 12
      }),
      calPre: pre.map(([l, A, B]) => {
        const on = st.calA === A && st.calB === B;
        return {
          l,
          bg: on ? 'oklch(0.62 0.18 42)' : 'rgba(255,255,255,0.03)',
          c: on ? '#fff' : '#d5dbe4',
          bd: on ? 'oklch(0.62 0.18 42)' : 'rgba(184,193,206,0.18)',
          onClick: sel(A, B)
        };
      }),
      calNDays: String(nd),
      calNdIn: e => this.setState({
        calNd: Math.max(1, Math.min(3650, +e.target.value || 1))
      }),
      calNdGo: () => sel(endN - nd + 1, endN)(),
      calNdEnd: fd(endN),
      calApply: () => {
        if (pb == null) return;
        const ea = Math.max(0, sa),
          eb = Math.min(N - 1, sb);
        this.setState({
          rngA: sa,
          rngB: sb,
          day: ea <= eb ? eb - ea : 0,
          calOpen: false,
          calA: null,
          calB: null,
          calHv: null,
          calVM: null,
          sZoom: null,
          cDays: null,
          cEnd: null,
          cFocus: null,
          hover: null,
          verPor: null
        });
      },
      verOpts: [{
        v: 'all',
        l: 'Todas',
        sel: st.verPor == null
      }, ...(this.data.empty ? [] : this.data.days.map((d, i) => ({
        v: String(i),
        l: d,
        sel: st.verPor === i
      })))],
      verKey: 'v' + (st.verPor ?? 'all') + '-' + a + '-' + b,
      verVal: st.verPor == null ? 'all' : String(st.verPor),
      ayVal: st.ayRes || 'medio',
      onVer: e => {
        const v = e.target.value;
        this.setState(v === 'all' ? {
          verPor: null
        } : {
          verPor: +v,
          day: +v
        });
      },
      ayOpts: [{
        v: 'medio',
        l: 'Medio día',
        sel: (st.ayRes || 'medio') === 'medio'
      }, {
        v: 'dia',
        l: 'Día',
        sel: st.ayRes === 'dia'
      }],
      ayKey: 'ay' + (st.ayRes || 'medio'),
      onAy: e => this.setState({
        ayRes: e.target.value
      }),
      noDataT: 'Sin datos entre el ' + fd(a) + ' y el ' + fd(b),
      noDataS: 'Hay datos disponibles del ' + fd(0) + ' al ' + fd(N - 1) + '.',
      goAll: () => this.setState({
        rngA: 0,
        rngB: N - 1,
        day: N - 1
      })
    };
  },
  alarmVals(det) {
    const [z0, z1] = this.state.zm || [det.timeMin ?? 450, det.timeMax ?? 1350],
      T0 = z0 * 60,
      T1 = z1 * 60;
    const A = det.alarms,
      ah = this.state.ah;
    const hms = s => [Math.floor(s / 3600), Math.floor(s / 60) % 60, s % 60].map(v => String(v).padStart(2, '0')).join(':');
    const rt = s => s == null ? 'No atendida' : s >= 60 ? Math.floor(s / 60) + ' min ' + Math.round(s % 60) + ' s' : s.toFixed(0) + ' s';
    const pos = a => (a.sec - T0) / (T1 - T0) * 100;
    const reaction = a => {
      const start = Math.max(0, pos(a));
      const valid = a.att === true && Number.isFinite(a.react) && a.react > 0;
      const end = valid ? Math.min(100, pos(a) + a.react / (T1 - T0) * 100) : start;
      return {
        reactionOn: valid && end > start,
        reactionW: Math.max(0, end - start).toFixed(3) + '%'
      };
    };
    const yes = A.filter(a => a.att),
      avg = yes.length ? yes.reduce((x, a) => x + a.react, 0) / yes.length : null;
    const out = {
      alNo: String(A.length - yes.length),
      alYes: String(yes.length),
      alAvg: avg == null ? '—' : rt(avg),
      alarmPins: A.map((a, k) => ({
        ...reaction(a),
        vis: a.sec + a.dur >= T0 && a.sec <= T1,
        onClick: () => {
          const c = (a.sec + a.dur / 2) / 60,
            half = Math.max(7.5, a.dur / 60 * 2);
          this.setZoom(c - half, c + half);
        },
        left: Math.max(0, pos(a)).toFixed(2) + '%',
        w: Math.max(0, Math.min(100, pos(a) + a.dur / (T1 - T0) * 100) - Math.max(0, pos(a))).toFixed(3) + '%',
        c: a.att ? 'oklch(0.76 0.11 70)' : 'oklch(0.66 0.19 25)',
        fill: a.att ? 'rgba(4,12,24,0.7)' : 'oklch(0.66 0.19 25)',
        important: a.att === false,
        h: a.att ? "calc((100% - 1.481481vh) * " + (Math.min(a.react, 300) / 300 * 0.85).toFixed(3) + ')' : "calc(100% - 1.481481vh)",
        ring: k === ah ? "0 0 0 0.277778vh rgba(228,233,240,0.35)" : 'none',
        k,
        enter: () => this.state.ah !== k && this.setState({
          ah: k,
          hi: Math.max(0, Math.min(det.pts.length - 1, Math.round((a.sec / 60 - 450) / 5)))
        }),
        leave: () => this.setState({
          ah: null,
          hi: null
        })
      })).filter(p => p.vis),
      alTipOn: ah != null && !!A[ah],
      alTip: {}
    };
    out.alList = A.map((a, k) => ({
      time: hms(a.sec),
      dur: a.dur >= 60 ? Math.floor(a.dur / 60) + ' min ' + a.dur % 60 + ' s' : a.dur + ' s',
      react: rt(a.react),
      c: a.att ? 'oklch(0.76 0.11 70)' : 'oklch(0.66 0.19 25)',
      fill: a.att ? 'transparent' : 'oklch(0.66 0.19 25)',
      bg: k === ah ? 'rgba(46,179,238,0.12)' : 'transparent',
      onClick: () => {
        const c = (a.sec + a.dur / 2) / 60,
          half = Math.max(7.5, a.dur / 60 * 2);
        this.setZoom(c - half, c + half);
      },
      enter: () => this.state.ah !== k && this.setState({
        ah: k
      }),
      leave: () => this.setState({
        ah: null
      })
    }));
    out.alEmpty = A.length === 0;
    {
      const hi = this.state.hi,
        tS = hi != null && det.pts[hi] ? det.pts[hi].t * 60 : null;
      let ai = ah != null && A[ah] ? ah : -1;
      if (ai < 0 && tS != null) ai = A.findIndex(a => tS >= a.sec - 150 && tS <= a.sec + a.dur + 150);
      const fd = s => s >= 60 ? Math.floor(s / 60) + ' min ' + s % 60 + ' s' : s + ' s';
      if (ai >= 0) {
        const a = A[ai],
          c = a.att ? 'oklch(0.76 0.11 70)' : 'oklch(0.66 0.19 25)';
        out.alL = {
          c,
          fill: a.att ? 'transparent' : c,
          badge: a.att ? 'Atendida' : 'No atendida',
          rows: [{
            l: 'Inicio',
            v: hms(a.sec),
            c: '#e4e9f0'
          }, {
            l: 'Fin',
            v: hms(a.sec + a.dur),
            c: '#e4e9f0'
          }, {
            l: 'Duración',
            v: fd(a.dur),
            c: '#e4e9f0'
          }, {
            l: 'Det. máx / tot',
            v: a.dmax + ' / ' + a.dtot,
            c: '#e4e9f0'
          }, {
            l: 'Reacción',
            v: rt(a.react),
            c
          }]
        };
      } else out.alL = {
        c: '#8793a6',
        fill: 'transparent',
        badge: A.length + ' en el día',
        rows: [{
          l: 'No atendidas',
          v: String(A.length - yes.length),
          c: A.length - yes.length ? 'oklch(0.66 0.19 25)' : '#5a667a'
        }, {
          l: 'Atendidas',
          v: String(yes.length),
          c: yes.length ? 'oklch(0.76 0.11 70)' : '#5a667a'
        }, {
          l: 'Reacción prom.',
          v: avg == null ? '—' : rt(avg),
          c: '#b8c1ce'
        }, {
          l: 'Duración prom.',
          v: A.length ? fd(Math.round(A.reduce((x, a) => x + a.dur, 0) / A.length)) : '—',
          c: '#b8c1ce'
        }, {
          l: '',
          v: '',
          c: '#5a667a'
        }]
      };
    }
    if (out.alTipOn) {
      const a = A[ah],
        p = det.pts[a.i],
        l = pos(a);
      out.alTip = {
        left: l.toFixed(2) + '%',
        tx: l > 75 ? 'translateX(-100%)' : l < 20 ? 'none' : 'translateX(-50%)',
        c: a.att ? 'oklch(0.76 0.11 70)' : 'oklch(0.66 0.19 25)',
        date: this.data.days[this.state.day] + ' · ' + hms(a.sec).slice(0, 5),
        estado: a.att ? 'Atendida' : 'No atendida',
        inicio: hms(a.sec),
        dur: a.dur >= 60 ? Math.floor(a.dur / 60) + ' min ' + a.dur % 60 + ' s' : a.dur + ' s',
        fin: hms(a.sec + a.dur),
        dmax: String(a.dmax),
        dtot: String(a.dtot),
        react: rt(a.react),
        act: p.act.toFixed(1) + ' %',
        tasa: p.tasa + ' kg/min',
        ppa: p.ppa.toFixed(0)
      };
    }
    return out;
  },
  rngVals(st) {
    const D = this.data,
      C = D.rows,
      N = D.days.length,
      sel = st.sel,
      hv = st.rgHov,
      OR = 'oklch(0.72 0.17 45)';
    const compared = (st.cmp8 || []).filter(ci => ci >= 0 && ci < C.length && ci !== sel),
      scope = [...new Set([sel, ...compared])],
      isAll = scope.length === C.length,
      scopeLabel = isAll ? 'Todas las jaulas' : scope.length === 1 ? C[scope[0]].name : scope.length + ' jaulas';
    const fT = h => {
      const m = Math.round(h * 60);
      return String(Math.floor(m / 60)).padStart(2, '0') + ':' + String(m % 60).padStart(2, '0');
    };
    const nf = v => Math.round(v).toLocaleString('es-CL');
    const defs = [{
      k: 'kg',
      l: 'Alimento entregado',
      // delivered_food already comes from SCAPP in tonnes; do not convert it again.
      g: c => c.ay || !Number.isFinite(c.kg) ? 0 : c.kg,
      f: v => v.toLocaleString('es-CL', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }) + ' t'
    }, {
      k: 'al',
      l: 'Alarmas',
      g: c => c.al,
      f: nf
    }, {
      k: 'vis',
      l: 'Visitas',
      g: c => c.vis,
      f: nf
    }];
    const q = (a, p) => {
      const s = a.slice().sort((x, y) => x - y),
        i = (s.length - 1) * p,
        lo = Math.floor(i);
      return s[lo] + (s[Math.min(s.length - 1, lo + 1)] - s[lo]) * (i - lo);
    };
    const dailyMode = scope.length === 1,
      periodLabel = D.days[0] + ' – ' + D.days[N - 1];
    const sourceLabel = x => C[x.ci].name;
    const selectPoint = x => this.setState({
      sel: x.ci,
      ...(x.di == null ? {} : {
        day: x.di
      }),
      cmp8: []
    });
    const rgCards = defs.map(m => {
      const all = dailyMode ? C[scope[0]].cells.map((cell, di) => ({
          ci: scope[0],
          di,
          hasData: !cell.missing,
          v: m.g(cell) || 0
        })) : scope.map(ci => {
          const reported = C[ci].cells.filter(cell => !cell.missing);
          return {
            ci,
            di: null,
            hasData: reported.length > 0,
            v: reported.reduce((sum, cell) => sum + (m.g(cell) || 0), 0)
          };
        }),
        // V1 compares days for one cage, but accumulated totals per cage when several/all are selected.
        ok = all.filter(x => x.hasData),
        nd = all.filter(x => !x.hasData);
      if (!ok.length) return {
        l: m.l,
        minV: '—',
        minC: 'Sin datos',
        maxV: '—',
        maxC: 'Sin datos',
        med: '50%',
        medV: 'sin datos',
        dots: [],
        disp: '',
        nd: nd.length + (dailyMode ? nd.length === 1 ? ' día sin datos' : ' días sin datos' : nd.length === 1 ? ' jaula sin datos' : ' jaulas sin datos'),
        hasNd: nd.length > 0,
        tipOn: false,
        tipL: '0',
        tipT: '',
        selT: scopeLabel
      };
      const vs = ok.map(x => x.v),
        mn = Math.min(...vs),
        mx = Math.max(...vs),
        med = q(vs, 0.5),
        span = Math.max(1e-9, mx - mn);
      const P = v => (4 + (v - mn) / span * 92).toFixed(2) + '%',
        lo = ok.find(x => x.v === mn),
        hi = ok.find(x => x.v === mx);
      const dots = ok.map(x => {
        const isS = x.ci === sel && (x.di == null || x.di === st.day),
          on = hv && hv.k === m.k && hv.ci === x.ci && hv.di === x.di;
        return {
          left: P(x.v),
          sz: isS || on ? "1.111111vh" : "0.833333vh",
          bg: isS ? '#ffffff' : 'oklch(0.75 0.11 190)',
          bd: isS ? "0.185185vh solid oklch(0.75 0.11 190)" : "0.138889vh solid rgba(6,14,28,0.9)",
          z: isS || on ? 3 : 1,
          enter: () => this.setState({
            rgHov: {
              k: m.k,
              ci: x.ci,
              di: x.di
            }
          }),
          click: () => selectPoint(x)
        };
      });
      const h = hv && hv.k === m.k ? all.find(x => x.ci === hv.ci && x.di === hv.di) : null,
        // Equal accumulated values share the exact same position. List every cage
        // represented by the hovered marker so overlapping dots are not hidden.
        hoveredSources = h && !dailyMode ? ok.filter(x => x.v === h.v).map(sourceLabel) : [];
      return {
        l: m.l,
        minV: m.f(mn),
        minC: sourceLabel(lo),
        maxV: m.f(mx),
        maxC: sourceLabel(hi),
        med: P(med),
        medV: 'mediana ' + m.f(med),
        dots,
        disp: mn > 0 ? 'máx = ' + (mx / mn).toFixed(1) + '× mín' : '',
        nd: nd.length ? nd.length + (dailyMode ? nd.length === 1 ? ' día sin datos' : ' días sin datos' : nd.length === 1 ? ' jaula sin datos' : ' jaulas sin datos') : '',
        hasNd: nd.length > 0,
        tipOn: !!h,
        tipL: h ? P(h.v) : '0',
        tipT: h ? (hoveredSources.length > 1 ? hoveredSources.length + ' jaulas: ' + hoveredSources.join(', ') : sourceLabel(h)) + ' · ' + m.f(h.v) : '',
        selT: dailyMode ? scopeLabel + ' · ' + ok.length + ' días' : scopeLabel + ' · acumulado del período'
      };
    });
    const H0 = 0,
      H1 = 24,
      X = h => ((h - H0) / (H1 - H0) * 100).toFixed(2) + '%';
    const hr = scope.map(ci => {
      const hours = this.feedingHours(ci),
        a = hours[0],
        b = hours[1];
      return {
        ci,
        a,
        b,
        aDay: hours[2],
        bDay: hours[3]
      };
    });
    const validHr = hr.filter(x => Number.isFinite(x.a) && Number.isFinite(x.b) && x.b >= x.a),
      e0 = validHr.length ? validHr.reduce((m, x) => x.a < m.a ? x : m) : null,
      e1 = validHr.length ? validHr.reduce((m, x) => x.b > m.b ? x : m) : null;
    const rgHrs = e0 && e1 ? [{
      l: X(e0.a),
      w: ((e1.b - e0.a) / (H1 - H0) * 100).toFixed(2) + '%',
      bg: '#ffffff',
      op: 1,
      sL: OR,
      eL: OR
    }] : [];
    const hourSource = (x, hour) => x ? fT(hour) + (scope.length > 1 ? ' · ' + C[x.ci].name : '') : 'Sin datos';
    const hourTip = (x, day, hour, label) => x ? label + ': ' + fT(hour) + ' · ' + day + ' · ' + C[x.ci].name : 'Sin datos';
    return {
      showRng: !!st.showRng,
      rgCards,
      rgHrs,
      rgLeave: () => this.setState({
        rgHov: null
      }),
      rgClose: () => this.setState({
        showRng: false,
        rgHov: null
      }),
      rgPer: D.days[0] + ' – ' + D.days[N - 1] + ' · ' + scopeLabel,
      rgT: [0, 3, 6, 9, 12, 15, 18, 21, 24].map(h => ({
        l: X(h),
        t: String(h).padStart(2, '0'),
        tx: h === H0 ? 'none' : h === H1 ? 'translateX(-100%)' : 'translateX(-50%)'
      })),
      rgE0: hourSource(e0, e0 && e0.a),
      rgE1: hourSource(e1, e1 && e1.b),
      rgE0Tip: hourTip(e0, e0 && e0.aDay, e0 && e0.a, 'Inicio más temprano'),
      rgE1Tip: hourTip(e1, e1 && e1.bDay, e1 && e1.b, 'Fin más tardío'),
      rgHH: e0 && e1 ? scopeLabel + ' · ' + fT(e0.a) + ' – ' + fT(e1.b) : 'Sin datos',
      rgHHTip: e0 && e1 ? hourTip(e0, e0.aDay, e0.a, 'Inicio') + ' | ' + hourTip(e1, e1.bDay, e1.b, 'Fin') : 'Sin datos'
    };
  }
};
export default logic;
